/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/* eslint-disable prefer-arrow-callback */
AUI().ready(
	/*
	This function gets loaded when all the HTML, not including the portlets, is
	loaded.
	*/

	() => {}
);

Liferay.Portlet.ready(
	/*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/

	(_portletId, _node) => {}
);

Liferay.on(
	'allPortletsReady',

	/*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

	() => {
		const messageCenterHeaderDismissAll = document.querySelector(
			'.message-center-header-content .header a.dismiss-all'
		);
		const messageCenterItemClear = document.querySelectorAll(
			'.message-center-list-item > a  button'
		);
		const messageListWrapper = document.querySelector(
			'.message-center-list'
		);

		document.querySelectorAll('.component-separator hr').forEach(hr  => {
			hr.setAttribute('aria-hidden', 'true');
		});

		document.querySelectorAll('.authorizations-header [data-lfr-editable-id][tabindex]').forEach(el  => {
			if(el.tagName.toLowerCase() === 'a' || el.tagName.toLowerCase() === 'button'){
				return;
			}
			el.removeAttribute('tabindex');
		});

		const observer = new MutationObserver(() => {
			if (document.querySelectorAll('.LPMcontainer').length) {
				const lpmContainer = document.querySelector('.LPMcontainer');
				lpmContainer.setAttribute('aria-hidden', 'true');
			}
		});
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});

		if (messageCenterHeaderDismissAll) {
			messageCenterHeaderDismissAll.addEventListener(
				'click',
				async (event) => {
					event.stopPropagation();
					event.preventDefault();

					await fetch(
						`/o/message-center/messages/dismiss-all?p_auth=${Liferay.authToken}`,
						{
							method: 'POST',
							headers: {'Content-Type': 'application/json'}
						}
					);

					let itemsList = document.querySelector(
						'.message-center-header-content ul'
					);
					itemsList.innerHTML = '';
					let headerLabel = document.querySelector('.messages-count');
					headerLabel.innerHTML = '0';
					let messageNotificationIndicatorContainer =
						document.querySelector('.message-center');
					messageNotificationIndicatorContainer.classList.add(
						'd-none'
					);
					messageCenterHeaderDismissAll.classList.add('d-none');
					messageListWrapper.classList.add('d-none');
				}
			);
		}

		const handleClearItem = async (event) => {
			event.stopPropagation();
			event.preventDefault();
			let currentTarget = event.currentTarget;
			let list = currentTarget.closest('.message-center-list-item');
			let href = list.querySelector('a').href.split('/');
			let messageId = href[href.length - 1];

			await fetch(
				`/o/message-center/messages/${messageId}/dismiss?p_auth=${Liferay.authToken}`,
				{
					method: 'PUT',
					headers: {'Content-Type': 'application/json'}
				}
			);

			const response = await fetch(
				`/o/message-center/messages?p_auth=${Liferay.authToken}`,
				{
					method: 'GET',
					headers: {'Content-Type': 'application/json'}
				}
			);
			let {newMessageCount} = await response.json();

			if (newMessageCount && newMessageCount > 10) {
				newMessageCount = '10+';
			}

			list.remove();

			let headerLabel = document.querySelector('.messages-count');
			headerLabel.innerText = newMessageCount;
			let messageHeaderBadgeIndicator = document.querySelector(
				'.message-center-badge'
			);
			messageHeaderBadgeIndicator.innerText = `${newMessageCount}`;

			if (!newMessageCount || newMessageCount === 0) {
				let messageNotificationIndicatorContainer =
					document.querySelector('.message-center');
				messageNotificationIndicatorContainer.classList.add('d-none');
				messageCenterHeaderDismissAll.classList.add('d-none');
				messageListWrapper.classList.add('d-none');
			}
		};

		if (messageCenterItemClear) {
			messageCenterItemClear.forEach((clearItem) => {
				clearItem.addEventListener('click', handleClearItem);
			});
		}
	}
);
